import { AssessModel } from "domains/models/AssessModel";
import { EmployeeModel } from "domains/models/EmployeeModel";
import { TaskModel } from "domains/models/TaskModel";
import { UserModel } from "domains/models/UserModel";
import M5APIs from "m5/M5APIs";
import { employeeList, M5User } from "m5/models/M5User";
import { makeAutoObservable, action, computed, observable } from "mobx";
import moment from "moment";
import * as config from "../../../_config";

class MyPageStore {
  @observable private _containers = [];
  @observable private _myInfo: UserModel = {
    email: "",
    id: "",
    names: {
      fullname: "",
    },
    orgCode: "",
    paid: false,
    status: "",
    tier: "",
    username: "",
    userData: {
      deptName: "",
      jobTitle: "",
    },
  };
  @observable private _total = 0;
  @observable private _targets: Array<UserModel> = [];
  @observable private _tabValue: string = "downwards";
  @observable private _isLoading: boolean = false;
  @observable _assessList: Array<AssessModel> = [];
  @observable private _isOpenModal: boolean = false;
  @observable private _last30dayCount: number = 0;
  @observable private _quaterCount: number = 0;
  @observable private _halfCount: number = 0;
  @observable private _yearCount: number = 0;
  @observable private _totalEmojiCount: number = 0;
  @observable private _filterValue: string = "";
  @observable private _quarterGoal: string = "";
  @observable private _semiAnnualGoal: string = "";

  constructor() {
    makeAutoObservable(this);
  }

  @action
  async fetchMyInfo() {
    try {
      this._isLoading = true;
      const res = await M5APIs.fetchMyInfo();
      this._myInfo = res;
      this._quarterGoal = res.userData?.quarterGoal;
      this._semiAnnualGoal = res.userData?.semiAnnualGoal;
      return res;
    } catch (err: any) {
      throw err;
    } finally {
      this._isLoading = false;
    }
  }

  @action
  async fetchMyAssess(myInfo: UserModel) {
    try {
      this._isLoading = true;
      console.log(this.myInfo);
      const response: any = await M5APIs.fetchDocs<TaskModel>(
        config.BUCKET_TASK!,
        "TASK",
        {
          page: 0,
          pageSize: 50,
          orderBy: "updated",
          orderDirection: "DESC",
          fetchChildrenJson: [
            {
              types: "ASSESS",
              page: 0,
              pageSize: 20000,
            },
          ],
          where: {
            filters: [
              {
                condition: "AND",
                field: "created",
                compare: "BETWEEN",
                value: [
                  moment().subtract(1, "month").valueOf(),
                  moment().valueOf(),
                ],
              },
              {
                condition: "AND",
                field: "userData.`from`.`emailAddress`.`address`",
                compare: "=",
                value: myInfo.email,
              },
              {
                condition: "OR",
                field: "userData.`from`.`user`.`id`",
                compare: "=",
                value: myInfo.userData.graphId,
              },
            ],
          },
        }
      );

      console.log(response);
      if (response.children) {
        response.children?.forEach((child: AssessModel) => {
          if (child.userData?.emoticon) {
            this._totalEmojiCount = this._totalEmojiCount + 1;
          }
        });
      }
      return response;
    } catch (err) {
      throw err;
    } finally {
      this._isLoading = false;
    }
  }

  @action
  initStore() {
    this._last30dayCount = 0;
    this._quaterCount = 0;
    this._halfCount = 0;
    this._yearCount = 0;
  }

  @action
  async fetchTaskListOfStatus(myInfo: UserModel) {
    this._isLoading = true;

    this.initStore();
    const response: any = await M5APIs.fetchDocById(
      myInfo.userData.aggregationId!,
      "",
      "AGGREGATION",
      {
        fetchLinkedIds: true,
      }
    );

    if (
      response.docs.userData.assessList &&
      response.docs.userData.assessList.length !== 0
    ) {
      // downwards
      if (this._tabValue === "downwards") {
        response.docs.userData.assessList =
          response.docs.userData.assessList.filter((assess: AssessModel) => {
            return this.myInfo.userData.downwardsList?.find(
              (li: employeeList) => li.id === assess.userId
            );
          });
      } else if (this._tabValue === "peer") {
        response.docs.userData.assessList =
          response.docs.userData.assessList.filter((assess: AssessModel) => {
            return this.myInfo.userData.peerList?.find(
              (li: employeeList) => li.id === assess.userId
            );
          });
      } else {
        response.docs.userData.assessList.forEach((assess: AssessModel) => {
          this.myInfo.userData.peerList?.forEach((li: employeeList) => {
            if (li.id === assess.userId) {
              assess.userData = {
                ...assess.userData,
                ...{ isPeer: true },
              };
            }
          });
        });
      }

      for (let i = 0; i < response.docs.userData.assessList.length; i++) {
        let userRes = await M5APIs.fetchUserById(
          {},
          response.docs.userData.assessList[i].userId
        );
        response.docs.userData.assessList[i].user = userRes.user;
      }

      response.docs.userData.assessList =
        response.docs.userData.assessList.sort(
          (a: any, b: any) => b.created - a.created
        );
      for (let i = 0; i < response.docs.userData.assessList.length; i++) {
        if (response.docs.userData.assessList[i].subtype === "VISIBLE") {
          if (
            response.docs.userData.assessList[i].userData.emoticon &&
            response.docs.userData.assessList[i].userData.emoticon !== 0
          ) {
            const createTime = response.docs.userData.assessList[i].created!;
            const curYear = moment().year();
            const curMonth = moment().month() + 1;
            //30일 카운트
            if (
              createTime > moment().subtract(1, "month").valueOf() &&
              createTime <= moment().valueOf()
            ) {
              this._last30dayCount = this._last30dayCount + 1;
            }

            // 1년 카운트
            let newYDate = new Date(curYear, 0, 1);
            let newYDate2 = new Date(curYear, 11, 31);
            if (
              createTime > moment(newYDate).valueOf() &&
              createTime <= moment(newYDate2).valueOf()
            ) {
              this._yearCount = this._yearCount + 1;
            }
            // 반기 카운트
            let startMonth = 0;
            let endMonth = 2;
            //전반기 일떄
            if (curMonth < 7) {
              startMonth = 0;
              endMonth = 5;
            }
            //후반기 일때
            else {
              startMonth = 6;
              endMonth = 11;
            }
            let neQDate = new Date(curYear, startMonth, 1);
            let newQDate2 = new Date(curYear, endMonth, 31);
            if (
              createTime > moment(neQDate).valueOf() &&
              createTime <= moment(newQDate2).valueOf()
            ) {
              this._halfCount = this._halfCount + 1;
            }
            let startHMonth = 0;
            let endHMonth = 2;
            // 1분기
            if (moment().format("Q") === "1") {
              startHMonth = 0;
              endHMonth = 2;
            }
            // 2분기
            else if (moment().format("Q") === "2") {
              startHMonth = 3;
              endHMonth = 5;
            }
            // 3분기
            else if (moment().format("Q") === "3") {
              startHMonth = 6;
              endHMonth = 8;
            }
            // 4분기
            else {
              startHMonth = 9;
              endHMonth = 11;
            }

            let newHDate = new Date(curYear, startHMonth, 1);
            let newHDate2 = new Date(curYear, endHMonth, 31, 23, 59, 59);

            if (
              createTime > moment(newHDate).valueOf() &&
              createTime <= moment(newHDate2).valueOf()
            ) {
              this._quaterCount = this._quaterCount + 1;
            }
          }
        }
      }
    }

    if (response.linkedDocs) {
      for (let i = 0; i < response.docs.userData.assessList?.length; i++) {
        for (let j = 0; j < response.linkedDocs?.length; j++) {
          if (
            response.docs.userData.assessList[i]?.parentId ===
            response.linkedDocs[j].id
          ) {
            response.docs.userData.assessList[i].parent =
              response.linkedDocs[j];
          }
        }
      }
    }

    if (response) {
      const groupedArr = response.docs.userData.assessList?.reduce(
        (acc: any, curr: any) => {
          console.log(curr);
          const parentId = curr.parentId;
          const group = acc[parentId] || [];

          return {
            ...acc,
            [parentId]: [...group, curr],
          };
        },
        {}
      );
      if (!groupedArr) {
        this._total = response.total;
        this._isLoading = false;
        return;
      }

      const result = Object.values(groupedArr);
      this._assessList = result as any;
      this._total = response.total;
      this._isLoading = false;
    }
  }

  @action
  async fetchTaskListOfStatusWithFilter() {
    this._isLoading = true;

    this.initStore();
    const response: any = await M5APIs.fetchDocById(
      this.myInfo.userData.aggregationId!,
      "",
      "AGGREGATION",
      {
        fetchLinkedIds: true,
      }
    );

    if (
      response.docs.userData.assessList &&
      response.docs.userData.assessList.length !== 0
    ) {
      // downwards
      if (this._tabValue === "downwards") {
        response.docs.userData.assessList =
          response.docs.userData.assessList.filter((assess: AssessModel) => {
            return this.myInfo.userData.downwardsList?.find(
              (li: employeeList) => li.id === assess.userId
            );
          });
      } else if (this._tabValue === "peer") {
        response.docs.userData.assessList =
          response.docs.userData.assessList.filter((assess: AssessModel) => {
            return this.myInfo.userData.peerList?.find(
              (li: employeeList) => li.id === assess.userId
            );
          });
      }

      if (response.linkedDocs) {
        for (let i = 0; i < response.docs.userData.assessList.length; i++) {
          for (let j = 0; j < response.linkedDocs?.length; j++) {
            if (
              response.docs.userData.assessList[i].parentId ===
              response.linkedDocs[j].id
            ) {
              response.docs.userData.assessList[i].parent =
                response.linkedDocs[j];
            }
          }
        }
      }

      // 날짜 필터
      let period: any;
      const curYear = moment().year();
      const curMonth = moment().month() + 1;
      if (this._filterValue === "quarter") {
        let startMonth = 0;
        let endMonth = 2;
        // 1분기
        if (moment().format("Q") === "1") {
          startMonth = 0;
          endMonth = 2;
        }
        // 2분기
        else if (moment().format("Q") === "2") {
          startMonth = 3;
          endMonth = 5;
        }
        // 3분기
        else if (moment().format("Q") === "3") {
          startMonth = 6;
          endMonth = 8;
        }
        // 4분기
        else {
          startMonth = 9;
          endMonth = 11;
        }
        let newDate = new Date(curYear, startMonth, 1);
        let newDate2 = new Date(curYear, endMonth, 31);
        period = {
          startDay: moment(newDate).valueOf(),
          endDay: moment(newDate2).valueOf(),
        };
      } else if (this._filterValue === "half") {
        let startMonth = 0;
        let endMonth = 2;
        //전반기 일떄
        if (curMonth < 7) {
          startMonth = 0;
          endMonth = 5;
        }
        //후반기 일때
        else {
          startMonth = 6;
          endMonth = 11;
        }
        let newDate = new Date(curYear, startMonth, 1);
        let newDate2 = new Date(curYear, endMonth, 31);

        period = {
          startDay: moment(newDate).valueOf(),
          endDay: moment(newDate2).valueOf(),
        };
      } else if (this._filterValue === "year") {
        let newDate = new Date(curYear, 0, 1);
        let newDate2 = new Date(curYear, 11, 31);
        period = {
          startDay: moment(newDate).valueOf(),
          endDay: moment(newDate2).valueOf(),
        };
      } else if (this._filterValue === "last30day") {
        period = {
          startDay: moment().subtract(1, "month").valueOf(),
          endDay: moment().valueOf(),
        };
      } else {
        period = {
          startDay: moment().subtract(1, "month").valueOf(),
          endDay: moment().valueOf(),
        };
      }

      response.docs.userData.assessList =
        response.docs.userData.assessList.filter((assess: AssessModel) => {
          return (
            assess.parent!.created! >= period.startDay &&
            assess.parent!.created! <= period.endDay
          );
        });

      for (let i = 0; i < response.docs.userData.assessList.length; i++) {
        let userRes = await M5APIs.fetchUserById(
          {},
          response.docs.userData.assessList[i].userId
        );
        response.docs.userData.assessList[i].user = userRes.user;
      }

      response.docs.userData.assessList =
        response.docs.userData.assessList.sort(
          (a: any, b: any) => b.created - a.created
        );
      for (let i = 0; i < response.docs.userData.assessList.length; i++) {
        if (response.docs.userData.assessList[i].subtype === "VISIBLE") {
          if (
            response.docs.userData.assessList[i].userData.emoticon &&
            response.docs.userData.assessList[i].userData.emoticon !== 0
          ) {
            const createTime = response.docs.userData.assessList[i].created!;
            const curYear = moment().year();
            const curMonth = moment().month() + 1;
            //30일 카운트
            if (
              createTime > moment().subtract(1, "month").valueOf() &&
              createTime <= moment().valueOf()
            ) {
              this._last30dayCount = this._last30dayCount + 1;
            }

            // 1년 카운트
            let newYDate = new Date(curYear, 0, 1);
            let newYDate2 = new Date(curYear, 11, 31);
            if (
              createTime > moment(newYDate).valueOf() &&
              createTime <= moment(newYDate2).valueOf()
            ) {
              this._yearCount = this._yearCount + 1;
            }
            // 반기 카운트
            let startMonth = 0;
            let endMonth = 2;
            //전반기 일떄
            if (curMonth < 7) {
              startMonth = 0;
              endMonth = 5;
            }
            //후반기 일때
            else {
              startMonth = 6;
              endMonth = 11;
            }
            let neQDate = new Date(curYear, startMonth, 1);
            let newQDate2 = new Date(curYear, endMonth, 31);
            if (
              createTime > moment(neQDate).valueOf() &&
              createTime <= moment(newQDate2).valueOf()
            ) {
              this._halfCount = this._halfCount + 1;
            }
            let startHMonth = 0;
            let endHMonth = 2;
            // 1분기
            if (moment().format("Q") === "1") {
              startHMonth = 0;
              endHMonth = 2;
            }
            // 2분기
            else if (moment().format("Q") === "2") {
              startHMonth = 3;
              endHMonth = 5;
            }
            // 3분기
            else if (moment().format("Q") === "3") {
              startHMonth = 6;
              endHMonth = 8;
            }
            // 4분기
            else {
              startHMonth = 9;
              endHMonth = 11;
            }

            let newHDate = new Date(curYear, startHMonth, 1);
            let newHDate2 = new Date(curYear, endHMonth, 31, 23, 59, 59);
            if (
              createTime > moment(newHDate).valueOf() &&
              createTime <= moment(newHDate2).valueOf()
            ) {
              this._quaterCount = this._quaterCount + 1;
            }
          }
        }
      }
    }

    if (response) {
      const groupedArr = response.docs.userData.assessList.reduce(
        (acc: any, curr: any) => {
          console.log(curr);
          const parentId = curr.parentId;
          const group = acc[parentId] || [];

          return {
            ...acc,
            [parentId]: [...group, curr],
          };
        },
        {}
      );

      const result = Object.values(groupedArr);

      console.log(result);
      console.log(response.docs.userData.assessList);
      this._assessList = result as any;
      this._total = response.total;
      this._isLoading = false;
    }
  }

  @computed
  get targets() {
    return this._targets;
  }
  @computed
  get total() {
    return this._total;
  }

  @computed
  get myInfo() {
    return this._myInfo;
  }
  @action
  setMyInfo(myInfo: UserModel) {
    this._myInfo = myInfo;
  }

  @action
  setIsOpenModal(isOpenModal: boolean) {
    this._isOpenModal = isOpenModal;
  }
  @action
  setTaskList(type: string) {
    if (type === "Downloads") {
      // this._assessList = temp1List;
    } else if (type === "peer") {
      // this._assessList = temp2List;
    } else {
      // this._assessList = temp3List;
    }
  }

  @action
  setFilterValue(value: string) {
    this._filterValue = value;
  }

  @action
  setMyInfoQuarter(value: string) {
    this._quarterGoal = value;
  }

  @action
  setMyInfoSemi(value: string) {
    this._semiAnnualGoal = value;
  }

  @action
  setTabValue(tabValue: string) {
    this._tabValue = tabValue;
  }

  @action
  async save() {
    try {
      this._isLoading = true;

      this._myInfo = {
        ...this._myInfo,
        ...{
          userData: {
            ...this._myInfo.userData,
            ...{
              quarterGoal: this._quarterGoal,
              semiAnnualGoal: this._semiAnnualGoal,
            },
          },
        },
      };

      await M5APIs.updateMyInfo(this._myInfo);
    } catch (err) {
      throw err;
    } finally {
      this._isLoading = false;
      this.fetchMyInfo();
    }
  }

  @computed
  get assessList() {
    return this._assessList;
  }

  @computed
  get tabValue() {
    return this._tabValue;
  }

  @computed
  get containers() {
    return this._containers;
  }
  @computed
  get isEmpty() {
    return this._containers.length === 0;
  }
  @computed
  get isOpenModal() {
    return this._isOpenModal;
  }
  @computed
  get isLoading() {
    return this._isLoading;
  }

  @computed
  get halfCount() {
    return this._halfCount;
  }

  @computed
  get yearCount() {
    return this._yearCount;
  }

  @computed
  get quaterCount() {
    return this._quaterCount;
  }

  @computed
  get last30dayCount() {
    return this._last30dayCount;
  }
  @computed
  get totalEmojiCount() {
    return this._totalEmojiCount;
  }

  @computed
  get filterValue() {
    return this._filterValue;
  }

  @computed
  get quarterGoal() {
    return this._quarterGoal;
  }

  @computed
  get semiAnnualGoal() {
    return this._semiAnnualGoal;
  }
}

export default MyPageStore;
